var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "agent-invitation-handler" }, [
    _c("div", { staticClass: "content" }, [
      _c(
        "div",
        { staticClass: "layout-column flex-center" },
        [_c("rbv-loading", { attrs: { label: "Loading, please wait..." } })],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }